import { showWarning, showInfo } from '../Components/utility/ui/notifications/Toaster';

export const validateWelderReportForm = (wiobj, requiredFields = []) => {
  const validations = {
    projectRequired: () => {
      if (requiredFields.includes('project') && !wiobj.WI_Project_No) {
        showWarning("Please Add Project No");
        return false;
      }
      return true;
    },

    slipStatusRequired: () => {
      if (requiredFields.includes('slipStatus') && !wiobj.WI_Slip_Status) {
        showWarning("Please Add Slip Status");
        return false;
      }
      return true;
    },

    fileFormatRequired: () => {
      if (requiredFields.includes('fileFormat') && !wiobj.WI_FileFormat) {
        showWarning("Please Select File Format");
        return false;
      }
      return true;
    },

    fromDateRequired: () => {
      if (requiredFields.includes('fromDate') && !wiobj.WI_From_Date) {
        showWarning("Please select From Date");
        return false;
      }
      return true;
    },

    toDateRequired: () => {
      if (requiredFields.includes('toDate') && !wiobj.WI_To_Date) {
        showWarning("Please select To Date");
        return false;
      }
      return true;
    },

    dateRange: () => {
      if (wiobj.WI_From_Date && wiobj.WI_To_Date && wiobj.WI_From_Date > wiobj.WI_To_Date) {
        showWarning("ToDate Should be Greater than or Equal to FromDate");
        return false;
      }
      return true;
    }
  };

  // Run all validations
  for (const validation of Object.values(validations)) {
    if (!validation()) {
      return false;
    }
  }

  return true;
};

export const showNoRecordsMessage = () => {
  showInfo("There are no records matching to filters.");
};

export const showSuccessMessage = () => {
  showInfo("Exported successfully");
};